import React from 'react';

/**
 * Skip to main content link for keyboard navigation and screen readers
 * WCAG 2.1 Success Criterion 2.4.1 (Bypass Blocks)
 */
const SkipToContent: React.FC = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:bg-green-600 focus:text-white focus:px-6 focus:py-3 focus:rounded-lg focus:shadow-xl focus:outline-none focus:ring-4 focus:ring-green-300 font-medium transition-all"
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
  );
};

export default SkipToContent;
